export enum OperationOutingsEnumFR {
  SORTIE_POSITIVE = 'SORTIE_POSITIVE',
  SORTIE_POSITIVE_EN_COURS = 'SORTIE_POSITIVE_EN_COURS',
  SORTIE_NEGATIVE = 'SORTIE_NEGATIVE',
  SORTIE_NEGATIVE_EN_COURS = 'SORTIE_NEGATIVE_EN_COURS',
  REMBOURSEMENT_INTERMEDIAIRE = 'REMBOURSEMENT_INTERMEDIAIRE',
}

export enum OperationOutingsEnum {
  POSITIVE = 'POSITIVE',
  PENDING_POSITIVE = 'PENDING_POSITIVE',
  NEGATIVE = 'NEGATIVE',
  PENDING_NEGATIVE = 'PENDING_NEGATIVE',
  INTERMEDIATE_REPAYMENT = 'INTERMEDIATE_REPAYMENT',
}

export const translateOperationOutings = (oo: OperationOutingsEnumFR): OperationOutingsEnum => {
  switch (oo) {
    case OperationOutingsEnumFR.SORTIE_POSITIVE:
      return OperationOutingsEnum.POSITIVE;
    case OperationOutingsEnumFR.SORTIE_POSITIVE_EN_COURS:
      return OperationOutingsEnum.PENDING_POSITIVE;
    case OperationOutingsEnumFR.SORTIE_NEGATIVE:
      return OperationOutingsEnum.NEGATIVE;
    case OperationOutingsEnumFR.SORTIE_NEGATIVE_EN_COURS:
      return OperationOutingsEnum.PENDING_NEGATIVE;
    case OperationOutingsEnumFR.REMBOURSEMENT_INTERMEDIAIRE:
      return OperationOutingsEnum.INTERMEDIATE_REPAYMENT;
  }
};
